<div id="mySidenav" class="sidenav shadow"
  [ngClass]="{'sidenavRight': !brandInfo.leftAlignNav,'sidenavLeft': brandInfo.leftAlignNav}" style="display: none"
  role="dialog" aria-live="assertive">
  <app-close-button (callbackFunction)="closeNav()"></app-close-button>
  @if (brandInfo.brand !== 'Porsche') {
    <div class="brand side-logo" style="cursor: pointer;"
      (click)="closeNav(); redirectToHome()">
      <img [src]="logo?.url ? logo.url : ''" [alt]="logo?.alt" />
    </div>
  }
  @if (brandInfo.brand === 'Porsche') {
    <div class="brand side-logo" style="cursor: pointer;"
      (click)="closeNav(); redirectToHome()">
      <img [src]="'/assets/icons/porsche/porsche-crest.png'" />
    </div>
  }

  <!-- Nav Products Drop Down Menu -->
  <div class="w-100 float-left">
    @if (showSDLogout && (brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link || brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link)) {
      <span mdbDropdown class="nav-item nav-buttons d-sm-inline-block" style="white-space: nowrap;">
        <a id="sidenavShopDropdownToggle" mdbDropdownToggle class="dropdown-toggle sidenav-item" tabindex="0" role="link">{{
        'NAV.SHOP' | translate }}</a>
        <span class="sidenav-item sub-item">
          <a id="sidenavProductsLink" href="/products" class="nav-item waves-light d-sm-inline-block">{{ 'NAV.PRODUCTS' | translate }}</a>
        </span>
        <span class="sidenav-item sub-item">
          @if (hasVehicle && checkForSD('VSC') && brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link) {
            <a id="sidenavVscLink"
              [href]="brandInfo.serviceVSCUrl.link" mdbWavesEffect
              class="nav-item waves-light d-sm-inline-block"
            style="white-space: nowrap;">{{brandInfo.serviceVSCUrl.text}}</a>
          }
          @if (hasVehicle && checkForSD('PPM') && brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link) {
            <a id="sidenavPpmLink"
              [href]="brandInfo.servicePPMUrl.link" mdbWavesEffect
              class="nav-item waves-light d-sm-inline-block"
            style="white-space: nowrap;">{{brandInfo.servicePPMUrl.text}}</a>
          }
        </span>
      </span>
    }
  </div>

  <div class="w-100 float-left">
    @if (!showSDLogout && productLinks && productLinks.length > 0 && productLinks[0]?.plan_name && brandInfo.brand !== 'Lambo' && !useProductSubmenuNav) {
      <span mdbDropdown>
        <a id="sidenavShopDropdownToggleNonSD" mdbDropdownToggle class="sidenav-item dropdown-toggle" tabindex="0" role="link">{{
        'NAV.SHOP' | translate }}</a>
        @for (link of productLinks; track link; let i = $index) {
          <span class="sidenav-item sub-item">
            <a id="sidenavPlanLink{{i}}" [href]="link.plan_link" class="d-sm-inline-block nav-buttons"
            style="white-space: nowrap;">{{link.plan_name}}</a>
            @if (hasVehicle && checkForPrduct(link.product_keys)) {
              <a id="sidenavRatesPageLink{{i}}" [href]="link.rates_page_link" mdbWavesEffect
                class="waves-light d-sm-inline-block nav-buttons secondary-link"
              style="white-space: nowrap;">{{link.rates_page_name}}</a>
            }
          </span>
        }
      </span>
    }

    @if (useProductSubmenuNav && showSDLogout) {
      <a id="sidenavPorscheShopLink" (click)="closeNav()"
        href="/products" class="sidenav-item" [ngClass]="{'dropdown-toggle': (showSubmenuICE || showSubmenuEV || showSubmenuTW)}">{{
      'NAV.SHOP' | translate }}</a>
    }

    @if (useProductSubmenuNav && showSDLogout && showSubmenuICE) {
      <a id="sidenavPorscheVspIceLink" href="/vsp-pricing" class="sidenav-item sub-item" tabindex="0"
        (click)="closeNav()" routerLinkActive="active">{{
      'NAV.VSP' | translate }}</a>
    }

    @if (useProductSubmenuNav && showSDLogout && showSubmenuEV) {
      <a id="sidenavPorscheVspEvLink" href="/electric-vsp-pricing" class="sidenav-item sub-item"
        tabindex="0" (click)="closeNav()" routerLinkActive="active">{{
      'NAV.VSP' | translate }}</a>
    }

    @if (useProductSubmenuNav && showSDLogout && showSubmenuTW) {
      <a id="sidenavPorscheTawLink" class="sidenav-item sub-item" tabindex="0" href="/tire-wheel-pricing"
        (click)="closeNav()" routerLinkActive="active">{{
      'NAV.TAW' | translate }}</a>
    }

    @for (link of navLinks; track link; let i = $index) {
      <span class="nav-item" [ngClass]="{'active': currentURL == link.url}">
        @if (link.url !== '/service-drive') {
          @if (isInternalLink(link.url)) {
            <a id="sidenavNavLink{{i}}" [routerLink]="link.url" class="sidenav-item" routerLinkActive="active" (click)="closeNav()">{{link.text}}</a>
          } @else {
            <a id="sidenavNavLink{{i}}" [href]="link.url" class="sidenav-item" (click)="closeNav()">{{link.text}}</a>
          }
        }
      </span>
    }

    @if (!showSDLogout && customer == '') {
      <a id="sidenavLoginDropdownToggle" href="javascript:void(0)" (click)="closeNav()"
      class="sidenav-item dropdown-toggle">{{ 'NAV.LOGIN' | translate }}</a>
    }

    @if (!showSDLogout && customer == '') {
      <a id="sidenavMyAccountLink" href="javascript:void(0)" class="sidenav-item sub-item" tabindex="0"
        href="/verify-account" (click)="closeNav()" routerLinkActive="active">{{
      'NAV.MY_ACCOUNT' | translate }}</a>
    }

    @for (link of navLinks; track link) {
      <span>
        @if (link.url === '/service-drive' && !showSDLogout && customer === '') {
          <a id="sidenavDealerLink" role="link" href="javascript:void(0)"
            (click)="navigateWithRefresh('/service-drive')" (click)="closeNav()" class="sidenav-item sub-item ignore">{{
          'NAV.DEALER' | translate }}</a>
        }
      </span>
    }

    @if (showSDLogout) {
      <span class="sidenav-item" style="white-space: nowrap;">
        <a id="sidenavScanVinLink" style="display: inline-block;" href="javascript:void(0)" role="link" (click)="navigateWithRefresh('/service-drive')" tabindex="0"
        (click)="closeNav()" class="ignore">{{ 'NAV.SCAN_VIN' | translate }}</a>
      </span>
    }

    @if (shouldShowLogoutLink()) {
      <span class="sidenav-item" style="white-space: nowrap;">
        <a id="sidenavLogoutDealerAgentLink" style="display: inline-block;" href="javascript:void(0)" role="link" tabindex="0" (click)="closeNav()"
          (click)="logoutDealerAgent()" class="ignore"><mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
        style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;{{dealerAgent}}</a>
      </span>
    }

    @if (customer !== '') {
      <span class="sidenav-item" style="white-space: nowrap;">
        <a id="sidenavLogoutCustomerLink" style="display: inline-block;" role="link" tabindex="0" (click)="closeNav()" href="javascript:void(0)"
          (click)="callbackSignOut.emit()" class=""><mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
        style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;{{
        'NAV.LOGOUT' |
      translate }} {{customer}}</a>
    </span>
  }

  <a id="sidenavSupportLink" class="sidenav-item links" [routerLink]="helpLink" [href]="helpLink" aria-label="Visit our help center"
    (click)="goToHelp(); closeNav()">
    {{ 'NAV.SUPPORT' | translate }}
  </a>

</div>
</div>

@if (brandInfo.centerNav) {
  <div id="navbar" class="navbar navbar-toggleable-md double-nav" [containerInside]="false">
    <div class="row w-100"
      style="align-items: center; display: flex; flex-direction: row; justify-content: center; flex-wrap: nowrap;">
      @if (!isCheckoutPage && showMobile && brandInfo.leftAlignNav) {
        <div
          style="position:absolute; left: 15px; display: flex; align-items: center;">
          <span class="nav-item">
            <a id="mobileMenuButtonLeft" tabindex="0" role="button" class="nav-link waves-light nav-buttons" mdbWavesEffect (click)="openNav()"
              aria-label="Menu"> <span class=""> </span> <i class="fas fa-bars"></i></a>
            </span>
            <span class="nav-item shopping-cart-icon" [ngClass]="{'active': isCartPage}">
              <a id="shoppingCartIconLeft" tabindex="0" role="button" alt="" aria-hidden="true" class="nav-link waves-light nav-buttons"
                (click)="cartModalShow()" data-toggle="modal">
                <mdb-icon fas icon="shopping-cart"></mdb-icon>
                <span style="display: none;">Shopping Cart</span>
                @if (cartCount > 0) {
                  <span class="badge badge-primary">{{cartCount}}</span>
                }
              </a>
            </span>
            <span class="nav-item desktop">
              <a id="phoneNumberLinkLeft" role="link" href="tel:{{ branding.cs_phone_number }}" tabindex="0"
                class="phone_number nav-link waves-light d-sm-inline-block nav-buttons" mdbWavesEffect
                [attr.aria-label]="setCallUs(branding.cs_phone_number)"><span>{{ branding.cs_phone_number }}</span>
              </a>
            </span>
          </div>
        }
        @if (!isCheckoutPage && !showMobile && brandInfo.leftAlignNav) {
          <div id="navContainer" #navbarDiv>
            @if (!showSDLogout && productLinks && productLinks.length > 0 && productLinks[0]?.plan_name && brandInfo.brand !== 'Lambo' && !useProductSubmenuNav) {
              <span mdbDropdown
                class="nav-item float-right d-sm-inline-block nav-buttons">
                <a id="desktopShopDropdownToggle" mdbDropdownToggle class="dropdown-toggle nav-products" tabindex="0" role="link">{{
                'NAV.SHOP' | translate }}</a>
                <div class="dropdown-menu">
                  @for (link of productLinks; track link; let i = $index) {
                    <span class="">
                      <a id="desktopPlanLink{{i}}" [href]="link.plan_link" [ngClass]="{'active': currentURL == link.plan_link}" mdbWavesEffect
                      class="nav-item waves-light d-sm-inline-block" style="white-space: nowrap;">{{link.plan_name}}</a><br />
                      @if (hasVehicle && checkForPrduct(link.product_keys)) {
                        <a id="desktopRatesPageLink{{i}}"
                          [ngClass]="{'active': currentURL == link.rates_page_link}" [href]="link.rates_page_link" mdbWavesEffect
                          class="nav-item waves-light d-sm-inline-block secondary-link"
                        style="white-space: nowrap;">{{link.rates_page_name}}</a>
                      }
                    </span>
                  }
                </div>
              </span>
            }
            <!-- Nav Products Drop Down Menu -->
            @if (showSDLogout && (brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link || brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link)) {
              <span mdbDropdown class="nav-item float-right d-sm-inline-block nav-buttons">
                <a id="desktopShopDropdownToggleSD" mdbDropdownToggle class="dropdown-toggle nav-products" tabindex="0" role="link">{{
                'NAV.SHOP' | translate }}</a>
                <div class="dropdown-menu">
                  <span class="">
                    <a id="desktopProductsLinkSD" [href]="'/products'" mdbWavesEffect [ngClass]="{'active': currentURL.includes('/products')}"
                    class="nav-item waves-light d-sm-inline-block" style="white-space: nowrap;">{{ 'NAV.PRODUCTS' | translate }}</a><br />
                    @if (hasVehicle && checkForSD('VSC') && brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link) {
                      <a id="desktopVscLinkSD"
                        [href]="brandInfo.serviceVSCUrl.link" mdbWavesEffect [ngClass]="{'active': currentURL.includes(brandInfo.serviceVSCUrl.link) && brandInfo.serviceVSCUrl.link}"
                        class="nav-item waves-light d-sm-inline-block secondary-link"
                      style="white-space: nowrap;">{{brandInfo.serviceVSCUrl.text}}</a>
                    }
                    @if (hasVehicle && checkForSD('PPM') && brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link) {
                      <a id="desktopPpmLinkSD"
                        [href]="brandInfo.servicePPMUrl.link" mdbWavesEffect [ngClass]="{'active': currentURL.includes(brandInfo.servicePPMUrl.link) && brandInfo.servicePPMUrl.link}"
                        class="nav-item waves-light d-sm-inline-block secondary-link"
                      style="white-space: nowrap;">{{brandInfo.servicePPMUrl.text}}</a>
                    }
                  </span>
                </div>
              </span>
            }
            @if (useProductSubmenuNav && showSDLogout) {
              <span mdbDropdown class="nav-item float-right d-sm-inline-block nav-buttons">
                <a id="desktopPorscheShopDropdownToggle" mdbDropdownToggle class="dropdown-toggle nav-products" tabindex="0" role="link">{{
                'NAV.SHOP' | translate }}</a>
                <div class="dropdown-menu">
                  <span class="">
                    <a id="desktopPorscheProductsLink" [href]="'/products'" mdbWavesEffect [ngClass]="{'active': currentURL.includes('/products')}"
                    class="nav-item waves-light d-sm-inline-block" style="white-space: nowrap;">{{ 'NAV.PRODUCTS' | translate }}</a><br />
                    @if (showSubmenuICE) {
                      <a id="desktopPorscheVspIceLink" [href]="'/vsp-pricing'" mdbWavesEffect [ngClass]="{'active': currentURL === '/vsp-pricing'}"
                        class="nav-item waves-light d-sm-inline-block secondary-link" style="white-space: nowrap;">{{ 'NAV.VSP' | translate }}</a><br />
                    }
                    @if (showSubmenuEV) {
                      <a id="desktopPorscheVspEvLink" [href]="'/electric-vsp-pricing'" mdbWavesEffect [ngClass]="{'active': currentURL === '/electric-vsp-pricing'}"
                        class="nav-item waves-light d-sm-inline-block secondary-link" style="white-space: nowrap;">{{ 'NAV.VSP' | translate }}</a><br />
                    }
                    @if (showSubmenuTW) {
                      <a id="desktopPorscheTawLink" [href]="'/tire-wheel-pricing'" mdbWavesEffect [ngClass]="{'active': currentURL === '/tire-wheel-pricing'}"
                        class="nav-item waves-light d-sm-inline-block secondary-link" style="white-space: nowrap;">{{ 'NAV.TAW' | translate }}</a>
                    }
                  </span>
                </div>
              </span>
            }
            @for (link of navLinks; track link; let i = $index) {
              <span
                [ngClass]="{'active': currentURL == link.url, 'nav-item': link.url.toLowerCase() !== '/service-drive'}">
                @if (link && link.url && link.url.toLowerCase() !== '/service-drive') {
                  @if (isInternalLink(link.url)) {
                    <a id="desktopNavLink{{i}}" [routerLink]="link.url"
                      class="nav-link waves-light d-sm-inline-block nav-buttons" routerLinkActive="active">{{link.text}}</a>
                  } @else {
                    <a id="desktopNavLink{{i}}" [href]="link.url"
                      class="nav-link waves-light d-sm-inline-block nav-buttons">{{link.text}}</a>
                  }
                }
              </span>
            }
            <span class="nav-item" [ngClass]="{'active': isHelpPage}">
              <a id="desktopSupportLink" [routerLink]="helpLink" [href]="helpLink" tabindex="0"
                class="nav-link waves-light d-sm-inline-block nav-buttons links" mdbWavesEffect (click)="goToHelp($event)">
                {{ 'NAV.SUPPORT' | translate }}
              </a>
            </span>
            @if (showSDLogout && brandInfo.brand !== 'VCIVW') {
              <span class="nav-item nav-buttons float-right"
                style="white-space: nowrap;">
                <a id="desktopScanVinLink" style="display: inline-block;" role="link" (click)="navigateWithRefresh('/service-drive')" href="javascript:void(0)" tabindex="0"
                class="nav-link waves-light nav-buttons">{{ 'NAV.SCAN_VIN' | translate }}</a>
              </span>
            }
            @if (shouldShowLogoutLink()) {
              <span class="nav-item nav-buttons float-right" style="white-space: nowrap;">
                <mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
                style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;<a id="desktopLogoutDealerAgentLink" style="display: inline-block;" role="link"
              tabindex="0" (click)="logoutDealerAgent()" class="nav-link waves-light nav-buttons">{{dealerAgent}}</a>
            </span>
          }
          @if (customer !== '') {
            <span class="nav-item nav-buttons float-right" style="white-space: nowrap;">
              <mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
              style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;<a id="desktopLogoutCustomerLink" style="display: inline-block;" role="link"
              tabindex="0" (click)="callbackSignOut.emit()" class="nav-link waves-light nav-buttons">{{ 'NAV.LOGOUT' |
            translate }} {{customer}}</a>
          </span>
        }
        @if (!showSDLogout && customer == '') {
          <div class="nav-item float-right d-sm-inline-block nav-buttons myaccount"
            mdbDropdown>
            <a id="desktopLoginDropdownToggle" mdbDropdownToggle class="dropdown-toggle" tabindex="0" role="link">{{ 'NAV.LOGIN' | translate }}</a>
            <div class="dropdown-menu">
              <a id="desktopMyAccountLink" role="link" class="waves-light d-sm-inline-block nav-buttons" href="/my-account" routerLinkActive="active"
                [ngClass]="{'active': currentURL == '/my-account' || currentURL == '/verify-account'}" mdbWavesEffect>{{
              'NAV.MY_ACCOUNT' | translate }}</a><br />
              @for (link of navLinks; track link) {
                <span>
                  @if (link.url === '/service-drive') {
                    <a id="desktopDealerLink" role="link" href="/service-drive" (click)="resetSession()"
                      [ngClass]="{'active': currentURL == link.url}" class="waves-light d-sm-inline-block nav-buttons"
                    mdbWavesEffect>{{ 'NAV.DEALER' | translate }}</a>
                  }
                </span>
              }
            </div>
          </div>
        }
        <span class="call nav-item">
          <a id="desktopPhoneNumberLink" role="link" href="tel:{{ branding.cs_phone_number }}" tabindex="0"
            class="phone_number nav-link waves-light d-sm-inline-block nav-buttons" mdbWavesEffect
            [attr.aria-label]="setCallUs(branding.cs_phone_number)">
            <span>{{ branding.cs_phone_number }}</span>
          </a>
        </span>
        <span class="nav-item shopping-cart-icon" [ngClass]="{'active': isCartPage}">
          <a id="desktopShoppingCartIcon" tabindex="0" role="button" alt="" aria-hidden="true" class="nav-link waves-light nav-buttons"
            (click)="cartModalShow()" data-toggle="modal">
            <mdb-icon fas icon="shopping-cart"></mdb-icon>
            <span style="display: none;">Shopping Cart</span>
            @if (cartCount > 0) {
              <span class="badge badge-primary">{{cartCount}}</span>
            }
          </a>
        </span>
      </div>
    }
    <div class="" style="display: flex;">
      <a id="navbarBrandLinkCenter" class="navbar-brand" style="display: flex; flex-direction: column; justify-content: space-around;"
        (click)="redirectToHome()" style="cursor: pointer;">
        @if (brandInfo.brand == 'Porsche') {
          <img class="logo mobile"
            [src]="'/assets/icons/porsche/porsche-crest.png'" />
        }
        <img class="logo desktop light" style="position: absolute;"
          [src]="'https://images.prismic.io/sgidigital-dev/Z1xh7ZbqstJ98fIi_porsche_logotypeWht.png?auto=format,compress'" />
        @if (brandInfo.brand == 'Porsche') {
          <img class="logo desktop dark" [src]="logo?.url ? logo.url : ''"
            [alt]="logo?.alt" />
        }
        @if (brandInfo.brand != 'Porsche') {
          <img class="logo" [src]="logo?.url ? logo.url : ''" [alt]="logo?.alt" />
        }
      </a>
      @if (dealerName) {
        <div class="nav-dealer">{{dealerName}}</div>
      }
    </div>
    @if (!isCheckoutPage && showMobile && !brandInfo.leftAlignNav) {
      <div
        style="position:fixed; right: 15px; display: flex; align-items: center;">
        <span class="nav-item desktop">
          <a id="phoneNumberLinkRight" role="link" href="tel:{{ branding.cs_phone_number }}" tabindex="0"
            class="phone_number nav-link waves-light d-sm-inline-block nav-buttons" mdbWavesEffect
            [attr.aria-label]="setCallUs(branding.cs_phone_number)"><span>{{ branding.cs_phone_number }}</span>
          </a>
        </span>
        <span class="nav-item shopping-cart-icon" [ngClass]="{'active': isCartPage}">
          <a id="shoppingCartIconRight" tabindex="0" role="button" alt="" aria-hidden="true" class="nav-link waves-light nav-buttons"
            (click)="cartModalShow()" data-toggle="modal">
            <mdb-icon fas icon="shopping-cart"></mdb-icon>
            <span style="display: none;">Shopping Cart</span>
            @if (cartCount > 0) {
              <span class="badge badge-primary">{{cartCount}}</span>
            }
          </a>
        </span>
        <span class="nav-item">
          <a id="mobileMenuButtonRight" tabindex="0" role="button" class="nav-link waves-light nav-buttons" mdbWavesEffect (click)="openNav()"
            aria-label="Menu"> <span class=""> </span> <i class="fas fa-bars"></i></a>
          </span>
        </div>
      }
      @if (isCheckoutPage) {
        <div class="checkout nav-item float-right">
          <h3>{{ 'CART_CHECKOUT.CHECKOUT' | translate }}</h3>
        </div>
      }
    </div>
  </div>
}

@if (!brandInfo.centerNav) {
  <mdb-navbar id="navbar" SideClass="navbar navbar-toggleable-md scrolling-navbar double-nav fixed-top"
    [containerInside]="false" mdbStickyHeader>
    <div class="row w-100"
      style="align-items: center; display: flex; flex-direction: row; justify-content: space-between; flex-wrap: nowrap;">
      <div class="" style="display: flex;">
        <a id="navbarBrandLink" class="navbar-brand" style="display: flex; flex-direction: column; justify-content: space-around; cursor: pointer;"
          (click)="redirectToHome()">
          <img class="logo" [src]="logo?.url ? logo.url : ''" [alt]="logo?.alt" />
        </a>
        @if (dealerName) {
          <div class="nav-dealer">{{dealerName}}</div>
        }
      </div>
      @if (!isCheckoutPage && !showMobile) {
        <div id="navContainer" #navbarDiv>
          @if (!showSDLogout && productLinks && productLinks.length > 0 && productLinks[0]?.plan_name && brandInfo.brand !== 'Lambo' && !useProductSubmenuNav) {
            <span mdbDropdown
              class="nav-item float-right d-sm-inline-block nav-buttons">
              <a id="desktopShopDropdownToggleNonCenter" mdbDropdownToggle class="dropdown-toggle nav-products" tabindex="0" role="link">{{
              'NAV.SHOP' | translate }}</a>
              <div class="dropdown-menu">
                @for (link of productLinks; track link; let i = $index) {
                  <span class="">
                    <a id="desktopPlanLinkNonCenter{{i}}" [href]="link.plan_link" [ngClass]="{'active': currentURL == link.plan_link}" mdbWavesEffect
                    class="nav-item waves-light d-sm-inline-block" style="white-space: nowrap;">{{link.plan_name}}</a><br />
                    @if (hasVehicle && checkForPrduct(link.product_keys)) {
                      <a id="desktopRatesPageLinkNonCenter{{i}}"
                        [ngClass]="{'active': currentURL == link.rates_page_link}" [href]="link.rates_page_link" mdbWavesEffect
                        class="nav-item waves-light d-sm-inline-block secondary-link"
                      style="white-space: nowrap;">{{link.rates_page_name}}</a>
                    }
                  </span>
                }
              </div>
            </span>
          }
          <!-- Nav Products Drop Down Menu -->
          @if (showSDLogout && (brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link || brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link)) {
            <span mdbDropdown class="nav-item float-right d-sm-inline-block nav-buttons">
              <a id="desktopShopDropdownToggleSDNonCenter" mdbDropdownToggle class="dropdown-toggle nav-products" tabindex="0" role="link">{{
              'NAV.SHOP' | translate }}</a>
              <div class="dropdown-menu">
                <span class="">
                  <a id="desktopProductsLinkSDNonCenter" [href]="'/products'" mdbWavesEffect [ngClass]="{'active': currentURL.includes('/products')}"
                  class="nav-item waves-light d-sm-inline-block" style="white-space: nowrap;">{{ 'NAV.PRODUCTS' | translate }}</a><br />
                  @if (hasVehicle && checkForSD('VSC') && brandInfo.serviceVSCUrl && brandInfo.serviceVSCUrl.link) {
                    <a id="desktopVscLinkSDNonCenter"
                      [href]="brandInfo.serviceVSCUrl.link" mdbWavesEffect [ngClass]="{'active': currentURL.includes(brandInfo.serviceVSCUrl.link) && brandInfo.serviceVSCUrl.link}"
                      class="nav-item waves-light d-sm-inline-block secondary-link"
                    style="white-space: nowrap;">{{brandInfo.serviceVSCUrl.text}}</a>
                  }
                  @if (hasVehicle && checkForSD('PPM') && brandInfo.servicePPMUrl && brandInfo.servicePPMUrl.link) {
                    <a id="desktopPpmLinkSDNonCenter"
                      [href]="brandInfo.servicePPMUrl.link" mdbWavesEffect [ngClass]="{'active': currentURL.includes(brandInfo.servicePPMUrl.link) && brandInfo.servicePPMUrl.link}"
                      class="nav-item waves-light d-sm-inline-block secondary-link"
                    style="white-space: nowrap;">{{brandInfo.servicePPMUrl.text}}</a>
                  }
                </span>
              </div>
            </span>
          }
          @for (link of navLinks; track link; let i = $index) {
            <span
              [ngClass]="{'active': currentURL == link.url, 'nav-item': link && link.url && link.url.toLowerCase() !== '/service-drive'}">
              @if (link && link.url && link.url.toLowerCase() !== '/service-drive') {
                @if (isInternalLink(link.url)) {
                  <a id="desktopNavLinkNonCenter{{i}}" [routerLink]="link.url"
                    class="nav-link waves-light d-sm-inline-block nav-buttons" routerLinkActive="active">{{link.text}}</a>
                } @else {
                  <a id="desktopNavLinkNonCenter{{i}}" [href]="link.url"
                    class="nav-link waves-light d-sm-inline-block nav-buttons">{{link.text}}</a>
                }
              }
            </span>
          }
          <span class="nav-item" [ngClass]="{'active': isHelpPage}">
            <a id="desktopSupportLinkNonCenter" [routerLink]="helpLink" [href]="helpLink" tabindex="0"
              class="nav-link waves-light d-sm-inline-block nav-buttons links" mdbWavesEffect (click)="goToHelp($event)">
              {{ 'NAV.SUPPORT' | translate }}
            </a>
          </span>
          @if (showSDLogout && brandInfo.brand !== 'VCIVW') {
            <span class="nav-item nav-buttons float-right"
              style="white-space: nowrap;">
              <a id="desktopScanVinLinkNonCenter" style="display: inline-block;" role="link" href="javascript:void(0)" (click)="navigateWithRefresh('/service-drive')" tabindex="0"
              class="nav-link waves-light nav-buttons">{{ 'NAV.SCAN_VIN' | translate }}</a>
            </span>
          }
          @if (shouldShowLogoutLink()) {
            <span class="nav-item nav-buttons float-right" style="white-space: nowrap;">
              <mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
              style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;<a id="desktopLogoutDealerAgentLinkNonCenter" style="display: inline-block;" role="link"
            tabindex="0" (click)="logoutDealerAgent()" class="nav-link waves-light nav-buttons">{{dealerAgent}}</a>
          </span>
        }
        @if (customer !== '') {
          <span class="nav-item nav-buttons float-right" style="white-space: nowrap;">
            <mdb-icon aria-hidden="true" width="100%" fas icon="sign-out-alt"
            style="font-size:13px; display: inline-block;"></mdb-icon>&nbsp;<a id="desktopLogoutCustomerLinkNonCenter" style="display: inline-block;" role="link"
            tabindex="0" (click)="callbackSignOut.emit()" class="nav-link waves-light nav-buttons">{{ 'NAV.LOGOUT' |
          translate }} {{customer}}</a>
        </span>
      }
      @if (!showSDLogout && customer == '') {
        <div class="nav-item float-right d-sm-inline-block nav-buttons myaccount"
          mdbDropdown>
          <a id="desktopLoginDropdownToggleNonCenter" mdbDropdownToggle class="dropdown-toggle" tabindex="0" role="link">{{ 'NAV.LOGIN' | translate }}</a>
          <div class="dropdown-menu">
            <a id="desktopMyAccountLinkNonCenter" role="link" class="waves-light d-sm-inline-block nav-item" href="/my-account" routerLinkActive="active"
              [ngClass]="{'active': currentURL == '/my-account' || currentURL == '/verify-account'}" mdbWavesEffect>{{
            'NAV.MY_ACCOUNT' | translate }}</a><br />
            @for (link of navLinks; track link) {
              <span>
                @if (link.url === '/service-drive') {
                  <a id="desktopDealerLinkNonCenter" role="link" href="/service-drive" (click)="resetSession()"
                    [ngClass]="{'active': currentURL == link.url}" class="waves-light d-sm-inline-block nav-item"
                  mdbWavesEffect>{{ 'NAV.DEALER' | translate }}</a>
                }
              </span>
            }
          </div>
        </div>
      }
      <span class="call nav-item">
        <a id="desktopPhoneNumberLinkNonCenter" role="link" href="tel:{{ branding.cs_phone_number }}" tabindex="0"
          class="phone_number nav-link waves-light d-sm-inline-block nav-buttons" mdbWavesEffect
          [attr.aria-label]="setCallUs(branding.cs_phone_number)">
          <span>{{ branding.cs_phone_number }}</span>
        </a>
      </span>
      <span class="nav-item shopping-cart-icon" [ngClass]="{'active': isCartPage}">
        <a id="desktopShoppingCartIconNonCenter" tabindex="0" role="button" alt="" aria-hidden="true" class="nav-link waves-light nav-buttons"
          (click)="cartModalShow()" data-toggle="modal">
          <mdb-icon fas icon="shopping-cart"></mdb-icon>
          <span style="display: none;">Shopping Cart</span>
          @if (cartCount > 0) {
            <span class="badge badge-primary">{{cartCount}}</span>
          }
        </a>
      </span>
    </div>
  }
  @if (isCheckoutPage) {
    <div class="checkout nav-item float-right">
      <h3>{{ 'CART_CHECKOUT.CHECKOUT' | translate }}</h3>
    </div>
  }
  @if (!isCheckoutPage && showMobile) {
    <div style="right:15px; display: flex; align-items: center;">
      <span class="call nav-item float-right box">
        <a id="phoneNumberLinkMobile" role="link" href="tel:{{ branding.cs_phone_number }}" tabindex="0"
          class="phone_number nav-link waves-light d-sm-inline-block nav-buttons" mdbWavesEffect
          [attr.aria-label]="'NAV.CALL_US' | translate">
          <span> {{ 'NAV.CALL_US' | translate }}</span>
        </a>
      </span>
      <span class="nav-item shopping-cart-icon" [ngClass]="{'active': isCartPage}">
        <a id="shoppingCartIconMobile" tabindex="0" role="button" alt="" aria-hidden="true" class="nav-link waves-light nav-buttons"
          (click)="cartModalShow()" data-toggle="modal">
          <mdb-icon fas icon="shopping-cart"></mdb-icon>
          <span style="display: none;">Shopping Cart</span>
          @if (cartCount > 0) {
            <span class="badge badge-primary">{{cartCount}}</span>
          }
        </a>
      </span>
      <span class="nav-item">
        <a id="mobileMenuButtonNonCenter" tabindex="0" role="button" class="nav-link waves-light nav-buttons" mdbWavesEffect (click)="openNav()"
          aria-label="Menu"> <span class=""> </span> <i class="fas fa-bars"></i></a>
        </span>
      </div>
    }
  </div>
</mdb-navbar>
}